import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';

export const WeatherContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CurrentTemp = styled.h2`
  margin: 0 0 5px 0;
  font-size: ${setRem(40)};
  font-weight: bold;
  line-height: 1;
  color: ${setColor.primaryColor};
  text-align: center;
`;

export const MetaTemp = styled.div`
  margin: 25px 0 0;
  line-height: 1.25;

  & span {
    display: block;
    text-align: center;
  }
`;

export const MetaTempLocation = styled.span`
  color: ${setColor.primaryColor};
  font-weight: bold;
`;

export const MetaTempDescription = styled.span`
  color: #000;
`;

export const MetaTempRainPresumption = styled.span`
  color: #000;
`;
